<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()">返回</div>
      <div class="big_tit">USDT管理</div>
    </div>
    <div class="wrap_box warp1">
      <p>
        <span>{{ allNum }}</span> {{ $t('account.withdrawalAccounts') }}
      </p>
    </div>
    <div class="wrap_box warp2">
      <div v-for="i in usdtList" :key="i.id" class="item">
        <img
          :src="require('../images/user/recharge' + i.type + '.png')"
          alt=""
        />
        <div class="item_detail">
          <p class="user_name ari_font">
            {{ i.bank }}
          </p>
          <p class="user_num">
            {{ i.account }}
          </p>
        </div>
        <div class="del" @click="delCard(i.id)" />
      </div>
    </div>
    <div class="basic_btn" @click="$router.push('/addcountUsdt')">
      {{ $t('account.add') }}
    </div>
  </div>
</template>

<script>
  import Fetch from '../../utils/fetch'

  export default {
    name: 'Account',
    data() {
      return {
        allNum: 0,
        data: {},
        usdtList: [] // 专门存储USDT数据
      }
    },
    created() {
      this.$parent.footer('user', false)
    },
    mounted() {
      document.getElementById('app').style.background =
        'linear-gradient(to bottom, #5674d3, #a8b6e5)'
      document.getElementById('app').style.marginBottom = '0px'
      this.start()
    },
    methods: {
      delCard(id) {
        Fetch('/user/bank_remove', { id: id }).then(() => {
          this.start()
        })
      },
      start() {
        Fetch('/user/my_bank').then((r) => {
          this.data = r.data
          
          // 更严格的过滤逻辑，只保留USDT数据
          this.usdtList = r.data.bank.filter(item => {
            const bankName = (item.bank || '').toLowerCase();
            const account = (item.account || '').toLowerCase();
            const type = item.type ? item.type.toString() : '';
            
            console.log('检查项目:', item); // 调试用，可以删除
            
            // 明确的USDT标识判断
            const isUSDT = 
              // 银行名称包含USDT相关关键词
              bankName.includes('usdt') || 
              bankName.includes('泰达币') || 
              bankName.includes('虚拟币') ||
              bankName.includes('数字货币') ||
              bankName.includes('加密货币') ||
              bankName.includes('digital') ||
              
              // 账号包含USDT相关关键词
              account.includes('usdt') ||
              
              // 类型标识（根据你的图片路径，type=4可能是USDT）
              type === '4' ||
              type.includes('usdt') ||
              
              // USDT地址格式判断
              (account.startsWith('t') && account.length === 34) || // TRC20
              (account.startsWith('0x') && account.length === 42);  // ERC20
            
            // 排除银行卡的明确标识
            const isBankCard = 
              bankName.includes('银行') ||
              bankName.includes('card') ||
              bankName.includes('储蓄') ||
              bankName.includes('借记') ||
              bankName.includes('工商') ||
              bankName.includes('建设') ||
              bankName.includes('农业') ||
              bankName.includes('中国') ||
              bankName.includes('招商') ||
              // 银行卡号格式（16-19位数字）
              (/^\d{16,19}$/.test(item.account));
            
            return isUSDT && !isBankCard;
          });
          
          this.allNum = this.usdtList.length;
          console.log('过滤后的USDT列表:', this.usdtList); // 调试用，可以删除
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .red_top_bg {
    height: 168px;
    // background-image: url(../images/user/moneybag/bg.png);
    // position: fixed;
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    background: linear-gradient(to left, #5674d3, #a8b6e5);
    height: 50px;
  }
  // .back_left {
  //   background: url(../../views/images/item/back_b.png) no-repeat center center;
  // }
  .big_tit {
    color: #fff;
  }

  .warp1 {
    padding: 20px;
    height: 40px;
    background: none;
    p {
      font-size: 14px;
      line-height: 40px;
      color: rgba(0, 0, 0, 0.8);
      font-weight: bold;
      background: #fff;
      border-radius: 10px;
      padding: 4px;
      span {
        color: #4a75f3;
      }
    }
  }

  .ari_font {
    height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
  }

  .warp2 {
    padding: 0 15px;
    margin-top: 12px;

    .item {
      padding: 14px 0 11px 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-bottom: 1px solid #ececec;

      &:last-child {
        border-bottom: none;
      }

      img {
        width: 30px;
        height: 30px;
      }

      .item_name {
        width: 65px;
      }
      .item_detail {
        margin-left: 10px;
      }

      .user_num {
        height: 17px;
        font-size: 12px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.6);
        line-height: 17px;
        margin-top: 10px;
      }

      .del {
        width: 20px;
        height: 20px;
        background: url(../images/item/del.png) no-repeat center center;
        background-size: 100% 100%;
        margin: 0 8px 0 auto;
      }
    }
  }

  .basic_btn {
    margin: 43px auto 0 auto;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    width: 90%;
    background: linear-gradient(to left, #756ff3, #399ffe);
    border-radius: 10px;
    color: #ffffff !important;
    text-align: center;
    margin-top: 40px !important;
  }
</style>